<template>
    <div>
        <a-card type="inner" size="small">
            <template slot="title" slot-scope="currentPageData">
                <strong>BUSINESS {{ title }}</strong>
            </template>

            <a-table class="pcp-table" :dataSource="tableData" :columns="tableColumns" rowKey="id" :pagination="false"  :rowClassName="(r) => r.is_heading || r.is_footer ? 'row-heading' : borders[r.achievement.status]">
                <div slot-scope="r" slot="number" class="text-center text-small">
                    <strong>{{ r.number }}</strong>
                </div>

                <div slot-scope="r" slot="kpi" class="text-small text-left">
                    <template v-if="r.is_heading || r.is_footer">
                        <strong>{{ r.name }}</strong>
                    </template>
                    <template v-else>
                        {{ r.name }}
                    </template>
                </div>

                <div slot-scope="r" slot="weight" class="text-small text-center" v-show="! r.is_heading">
                        <strong>{{ r.weight }} %</strong>
                   </div>

                   <div slot-scope="r" slot="target" class="text-small text-left" v-show="! r.is_heading && ! r.is_footer">
                       {{ r.target }}
                   </div>

                   <div slot-scope="r" slot="monthly_target" class="text-small" v-show="! r.is_heading && ! r.is_footer">
                        <strong>{{ number_format(r.target_ongoing) }}</strong>
                   </div>

                   <div slot-scope="r" slot="current_realization" class="text-small" v-show="! r.is_heading && ! r.is_footer">
                        <strong>{{ number_format(r.target_yield) }}</strong>
                   </div>

                   <div slot-scope="r" slot="percentage_project" class="text-small" v-show="! r.is_heading && ! r.is_footer">
                        <strong>{{ r.percentage_project }}%</strong>
                   </div>

                   <div slot-scope="r" slot="percentage_month" class="text-small" v-show="! r.is_heading && ! r.is_footer">
                        <strong>{{ targetMonth(r) }}%</strong>
                   </div>

                   <div slot-scope="r" slot="percentage_month" class="text-small" v-show="! r.is_heading && ! r.is_footer">
                        <strong>{{ targetMonth(r) }}%</strong>
                   </div>

                   <div slot-scope="r" slot="predicate" class="text-small" v-show="! r.is_heading && ! r.is_footer">
                       <template v-if="! r.is_heading && ! r.is_footer">
                           <strong>{{ r.predicate }}</strong>
                       </template>
                   </div>

                   <div slot-scope="r" slot="rate_weigth" class="text-small">
                       <div v-if="r.achievement.status === 'approved'">
                           {{ r.rate_weight }}
                       </div>
                       <div v-else-if="r.is_footer">
                           {{ r.rate_weight }}
                       </div>
                   </div>

                   <div slot-scope="r" slot="score_weigth" class="text-small">
                       <div v-if="r.achievement.status === 'approved'">
                           {{ parseFloat(r.score_weight).toFixed(2) }}
                       </div>
                       <div v-else-if="r.is_footer">
                           {{ parseFloat(r.score_weight).toFixed(2) }}
                       </div>
                   </div>

                   <div slot-scope="r" slot="rate_1" v-show="! r.is_heading && ! r.is_footer">
                       <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a"
                       v-if="r.predicate == 1 && r.achievement.status === 'approved'" style="font-size: 24px" />
                   </div>

                   <div slot-scope="r" slot="rate_2" class="text-small" v-show="! r.is_heading && ! r.is_footer">
                       <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a"
                       v-if="r.predicate == 2 && r.achievement.status === 'approved'" style="font-size: 24px"/>
                   </div>

                   <div slot-scope="r" slot="rate_3" class="text-small" v-show="! r.is_heading && ! r.is_footer">
                       <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a"
                       v-if="r.predicate == 3 && r.achievement.status === 'approved'" style="font-size: 24px"/>
                   </div>

                   <div slot-scope="r" slot="rate_4" class="text-small" v-show="! r.is_heading && ! r.is_footer">
                       <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a"
                       v-if="r.predicate == 4 && r.achievement.status === 'approved'" style="font-size: 24px"/>
                   </div>

                   <div slot-scope="r" slot="rate_5" class="text-small" v-show="! r.is_heading && ! r.is_footer">
                       <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a"
                       v-if="r.predicate == 5 && r.achievement.status === 'approved'" style="font-size: 24px"/>
                   </div>

                   <div slot-scope="r" slot="wom" class="text-small" v-show="! r.is_heading && ! r.is_footer" :style="'background-color: ' + colors['_' + r.predicate] ">
                        <div v-if="r.achievement.status === 'approved'">
                            &nbsp;
                        </div>
                   </div>

            </a-table>
        </a-card>
    </div>
</template>
<script>
import colors from '../../../pcp/wom'

const columns = [
    {
        key: 'no',
        align: 'center',
        width: 50,
        scopedSlots: {customRender: 'number'},
    }, {
        key: 'kpi',
        align: 'center',
        width: 300,
        title: 'Financial, Customer Focus, Business Internal, Learning & Growth',
        scopedSlots: {customRender: 'kpi'},
    }, {
        key: 'weight',
        align: 'center',
        title: 'Bobot',
        width: 80,
        scopedSlots: {customRender: 'weight'},
    }
]

const columnRlz = [
    {
        key: 'target',
        title: 'Target Selama Project Assigment',
        align: 'center',
        scopedSlots: {customRender: 'target'},
    }, {
        key: 'monthly_target',
        align: 'center',
        title: 'Target s.d Bln Laporan',
        width: 150,
        scopedSlots: {customRender: 'monthly_target'},
    }, {
        key: 'current_realization',
        align: 'center',
        title: 'Realisasi s.d Bln Laporan',
        width: 150,
        scopedSlots: {customRender: 'current_realization'},
    }, {
        key: 'percentage_project',
        align: 'center',
        title: 'Pencapaian Project',
        width: 110,
        scopedSlots: {customRender: 'percentage_project'},
    }, {
        key: 'percentage_month',
        align: 'center',
        title: 'Pencapaian Bulan',
        width: 110,
        scopedSlots: {customRender: 'percentage_month'},
    }, {
        key: 'predicate',
        align: 'center',
        title: 'Predikat',
        width: 100,
        scopedSlots: {customRender: 'predicate'},
    },
    {
        key: 'wom',
        align: 'center',
        title: 'WOM',
        width: 100,
        scopedSlots: {customRender: 'wom'},
    },
]

const columnScr = [
    {
        key: 'rate',
        title: 'Rating Penilaian',
        align: 'center',
        scopedSlots: {customRender: 'rate'},
        children: [
                {
                    key: 'rate_1',
                    title: '1',
                    align: 'center',
                    scopedSlots: {customRender: 'rate_1'},
                },
                {
                    key: 'rate_2',
                    title: '2',
                    align: 'center',
                    scopedSlots: {customRender: 'rate_2'},
                },
                {
                    key: 'rate_3',
                    title: '3',
                    align: 'center',
                    scopedSlots: {customRender: 'rate_3'},
                },
                {
                    key: 'rate_4',
                    title: '4',
                    align: 'center',
                    scopedSlots: {customRender: 'rate_4'},
                },
                {
                    key: 'rate_5',
                    title: '5',
                    align: 'center',
                    scopedSlots: {customRender: 'rate_5'},
                },
            ]
    }, {
        key: 'rate_weigth',
        align: 'center',
        title: 'Rating Bobot',
        scopedSlots: {customRender: 'rate_weigth'},
    },{
        key: 'score_weigth',
        align: 'center',
        title: 'Nilai Terbobot',
        scopedSlots: {customRender: 'score_weigth'},
    },
    {
        key: 'wom',
        align: 'center',
        title: 'WOM',
        width: 100,
        scopedSlots: {customRender: 'wom'},
    },
]

const columnSumRlz = [
     {
        key: 'target',
        align: 'center',
        title: 'Target Selama Project Assigment',
        scopedSlots: {customRender: 'target'},
    }, {
        key: 'recap',
        title: 'Rekapitulasi',
        align: 'center',
        scopedSlots: {customRender: 'recap'},
        children: [
                {
                    key: 'monthly_target',
                    title: 'Target',
                    align: 'center',
                    scopedSlots: {customRender: 'monthly_target'},
                },
                {
                    key: 'current_realization',
                    title: 'Realisasi',
                    align: 'center',
                    scopedSlots: {customRender: 'current_realization'},
                },
            ]
    }, {
        key: 'percentage_month',
        align: 'center',
        title: 'Pencapaian Bulan',
        scopedSlots: {customRender: 'percentage_month'},
    },
    {
        key: 'predicate',
        align: 'center',
        title: 'Predikat',
        scopedSlots: {customRender: 'predicate'},
    },
    {
        key: 'wom',
        align: 'center',
        title: 'wom',
        scopedSlots: {customRender: 'wom'},
    },
]

const columnSumKpi = [
     {
        key: 'target',
        align: 'center',
        title: 'Target Project',
        scopedSlots: {customRender: 'target'},
    }, {
        key: 'recap',
        title: 'Rekapitulasi',
        align: 'center',
        scopedSlots: {customRender: 'recap'},
        children: [
                {
                    key: 'monthly_target',
                    title: 'Target',
                    align: 'center',
                    scopedSlots: {customRender: 'monthly_target'},
                },
                {
                    key: 'current_realization',
                    title: 'Realisasi',
                    align: 'center',
                    scopedSlots: {customRender: 'current_realization'},
                },
            ]
    }, {
        key: 'predicate',
        title: 'Nilai Predikat',
        align: 'center',
        scopedSlots: {customRender: 'predicate'},
        children: [
                {
                    key: 'rate_1',
                    title: '1',
                    align: 'center',
                    scopedSlots: {customRender: 'rate_1'},
                },
                {
                    key: 'rate_2',
                    title: '2',
                    align: 'center',
                    scopedSlots: {customRender: 'rate_2'},
                },
                {
                    key: 'rate_3',
                    title: '3',
                    align: 'center',
                    scopedSlots: {customRender: 'rate_3'},
                },
                {
                    key: 'rate_4',
                    title: '4',
                    align: 'center',
                    scopedSlots: {customRender: 'rate_4'},
                },
                {
                    key: 'rate_5',
                    title: '5',
                    align: 'center',
                    scopedSlots: {customRender: 'rate_5'},
                },
            ]
    }, {
        key: 'score_weigth',
        align: 'center',
        title: 'Nilai Terbobot',
        width: 150,
        scopedSlots: {customRender: 'score_weigth'},
    },
]

export default {
    props: {
        type: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        data: {
            type: Array,
            default: []
        }
    },
    created() {
    },
    computed: {
        tableData() {
            return this.data
        },
        tableColumns() {
            let newColumns = this.columns

            switch(this.type){
                case 'RLZ':
                    let rlz = this.columnRlz
                    newColumns = [...newColumns,...rlz]
                    return newColumns
                case 'SUM-RLZ':
                    let sumRlz = this.columnSumRlz
                    newColumns = [...newColumns,...sumRlz]
                    return newColumns
                case 'SUM-KPI':
                    let sumKpi = this.columnSumKpi
                    newColumns = [...newColumns,...sumKpi]
                    return newColumns
                case 'SCR':
                    let scr = this.columnScr
                    newColumns = [...newColumns,...scr]
                    return newColumns
                default: return newColumns
            }
        },
    },
    data: () => ({
        colors,
        columns,
        columnRlz,
        columnScr,
        columnSumRlz,
        columnSumKpi,
        borders: {
            waiting: 'border-danger',
            pending: 'border-warning',
            approved: 'border-success',
        }
    }),
    methods: {
        targetMonth(r) {
            if (this.aspect === 'BRE')
                return r.percentage_month  + "%"

            return r.achievement.evaluation
        },
    }
}
</script>
